export enum Strategy {
  VOICE2VOICE = 'voice2voice',
  LLM_TTS = 'llm_tts',
  STT_LLM_TTS = 'stt_llm_tts',
}

export enum Provider {
  VERTEXAI = 'vertexai',
  OPENAI = 'openai',
  OPENROUTER = 'openrouter',
  PAYTM_INFERENCE = 'paytm_inference',
  GEMINI = 'gemini',
  ELEVENLABS = 'elevenlabs',
  GOOGLE = 'google',
  DEEPGRAM = 'deepgram',
  CARTESIA = 'cartesia',
  ANTHROPIC = 'anthropic',
  GROQ = 'groq',
  MURF = 'murf',
  SONIOX = 'soniox',
  SARVAM = 'sarvam',
}
export interface StrategyProviders {
  v2v: Provider | null;
  llm: Provider | null;
  tts: Provider | null;
  stt: Provider | null;
}
